// FileUploadPDP.ei1.Cart.View.js
// Cart-page behaviour for Copy lines: the line quantity is pages*copies
// (set on the PDP), so it must NOT be editable here, and we show a
// "page/pages" label next to it.
//
// DOM-driven detection (confirmed from the live cart): each quantity input
//   <input name="quantity" class="cart-item-summary-quantity-value ...">
// lives inside a .cart-lines-row ancestor that also contains the line's
// options text, including "Upload Page Count N" for Copy lines. So a line
// is a Copy line iff its .cart-lines-row text contains "upload page count".
// This is resilient to the matrix child id changing per option combo.
//
// Steppers in the same quantity wrapper:
//   .cart-item-summary-quantity-remove (minus) / .cart-item-summary-quantity-add (plus)
define('FileUploadPDP.ei1.Cart.View', [
    'Backbone'
], function (
    Backbone
) {
    'use strict';

    var ROW_SELECTOR = '.cart-lines-row';
    var PAGECOUNT_TEXT = 'upload page count';

    return Backbone.View.extend({

        apply: function apply() {
            var self = this;
            var inputs = document.querySelectorAll('input[name="quantity"]');

            Array.prototype.forEach.call(inputs, function (input) {
                var row = input.closest(ROW_SELECTOR);
                if (!row) { return; }
                var text = (row.textContent || '').toLowerCase();

                if (text.indexOf(PAGECOUNT_TEXT) > -1) {
                    self._lockInput(input);        // Copy line
                } else if (text.indexOf('copy service fee') > -1) {
                    self._lockFeeRow(input, row);  // Service fee line
                }
            });

            // Order: the fee row should sit directly BELOW its Copy line.
            self._reorderFeeRows();
        },

        // Lock the auto-added Copy Service Fee line: hide its quantity
        // control entirely, its image, and its Edit/Remove actions, and make
        // it non-interactive. Detected by the "Copy Service Fee" row text.
        _lockFeeRow: function _lockFeeRow(input, row) {
            var $row = $(row);
            // Idempotent: if we've already locked this row, do nothing. This
            // stops re-processing (and the DOM churn that caused blinking).
            if ($row.attr('data-ufm-fee-fixed') === 'true') {
                return;
            }
            $row.attr('data-ufm-fee-fixed', 'true').addClass('ufm-fee-row');

            // Hide the whole quantity control (not just disable - the fee
            // qty is managed automatically).
            $(input).closest('.cart-lines-qty-wrapper, .cart-lines-col-quantity')
                    .addClass('ufm-fee-qty-hidden');

            // Hide the product image/thumbnail, and the whole image cell/col
            // so no empty placeholder box remains.
            $row.find('img').addClass('ufm-fee-img-hidden');
            $row.find('.cart-detailed-item-view-image, .cart-item-cell-image, ' +
                      '.cart-lines-col-thumbnail, .cart-lines-col-image, ' +
                      '.transaction-line-views-cell-navigable-item-image')
                .addClass('ufm-fee-img-hidden');

            // Make the fee line NON-CLICKABLE: the product name/image normally
            // link to the item page - the customer shouldn't be able to open
            // the service fee item. Strip hrefs and block clicks on the row.
            $row.find('a').each(function () {
                var $a = $(this);
                var t = $.trim($a.text()).toLowerCase();
                // Remove Edit/Remove entirely.
                if (t === 'edit' || t === 'remove') {
                    $a.addClass('ufm-edit-hidden');
                    return;
                }
                // Neutralise any remaining link (name/image link to the item).
                $a.removeAttr('href')
                  .css({ 'pointer-events': 'none', 'cursor': 'default', 'color': 'inherit', 'text-decoration': 'none' })
                  .addClass('ufm-fee-nolink');
            });
            $row.find('.cart-item-actions-item-list-actionable-edit-button-edit, ' +
                      '.cart-item-actions-item-list-actionable-remove, ' +
                      'a[data-action="remove-item"], a[data-toggle="show-in-modal"], ' +
                      '.link-separator').addClass('ufm-edit-hidden');
        },

        // Move each Copy Service Fee row to directly after its Copy line.
        _reorderFeeRows: function _reorderFeeRows() {
            var $feeRows = $(ROW_SELECTOR).filter(function () {
                return (this.textContent || '').toLowerCase().indexOf('copy service fee') > -1;
            });
            var $copyRows = $(ROW_SELECTOR).filter(function () {
                return (this.textContent || '').toLowerCase().indexOf('upload page count') > -1;
            });
            // Simple case: put the (single) fee row right after the (first)
            // Copy row. For multiple Copy lines, place the fee after the last
            // Copy row so it reads as the aggregate per-order fee.
            if ($feeRows.length && $copyRows.length) {
                var feeRow = $feeRows.first()[0];
                var lastCopy = $copyRows.last()[0];
                // Only move if it's not ALREADY immediately after the last
                // Copy row - otherwise we'd churn the DOM every pass.
                if (lastCopy.nextElementSibling !== feeRow) {
                    $(feeRow).insertAfter(lastCopy);
                }
            }
        },

        _lockInput: function _lockInput(input) {
            var $input = $(input);

            // 1) Disable the input.
            $input.prop('disabled', true)
                  .attr('readonly', 'readonly')
                  .addClass('ufm-qty-locked');

            // 2) Hide the +/- steppers in this input's quantity wrapper, and
            //    tag the wrapper so CSS can lay this line out inline WITHOUT
            //    affecting other (non-Copy) cart lines.
            var $wrap = $input.closest('.cart-item-summary-item-list-actionable-input-qty, .cart-lines-qty-wrapper');
            $wrap.addClass('ufm-copy-qty-wrap');
            $wrap.find('.cart-item-summary-quantity-add, .cart-item-summary-quantity-remove')
                 .addClass('ufm-qty-step-hidden');

            // 3) Append "page"/"pages" once, right after the input.
            if (!$input.next('.ufm-pages-label').length) {
                var qty = parseInt($input.val(), 10);
                var word = (qty === 1) ? 'page' : 'pages';
                $('<span class="ufm-pages-label">' + word + '</span>').insertAfter($input);
            }

            // 4) Remove the Edit link on this Copy line (keep Remove) so the
            //    customer can't re-open and change options/quantity, which
            //    would break the pages*copies pricing. Scope to this line's
            //    row only. The edit link's exact class (confirmed from the
            //    cart DOM) is cart-item-actions-item-list-actionable-edit-
            //    button-edit; it also carries data-toggle="show-in-modal".
            var $row = $input.closest('.cart-lines-row');
            var $edit = $row.find(
                '.cart-item-actions-item-list-actionable-edit-button-edit, ' +
                'a[data-toggle="show-in-modal"]'
            );
            // Fallback: any anchor/button in the row whose text is "Edit".
            $row.find('a, button').each(function () {
                if ($.trim($(this).text()).toLowerCase() === 'edit') {
                    $edit = $edit.add(this);
                }
            });
            $edit.addClass('ufm-edit-hidden');
            // Also hide the trailing "|" separator that followed Edit, so we
            // don't leave a dangling "| Remove".
            $edit.next('.link-separator').addClass('ufm-edit-hidden');
            $edit.siblings('.link-separator').first().addClass('ufm-edit-hidden');
        }
    });
});
